export const RestService = {
    get: async function(url, headers) {
        headers["Content-Type"] = "application/json";
        if(!headers["device-id"]){
            headers["device-id"] = "test";
        }
        headers["sysbrew-x-token"] = localStorage.getItem('acumen.session');
        headers["app-version"] = global.appVersion;
        headers["platform"] = 'web';
        // if(url.includes('?')){
        //     url= `${url}&user_type=${localStorage.getItem('acumen.user_type')}&user_code=${localStorage.getItem('acumen.user_code')}`
        // } else {
        //     url= `${url}?user_type=${localStorage.getItem('acumen.user_type')}&user_code=${localStorage.getItem('acumen.user_code')}`
        // }
        return fetch(url, {
            method: "GET",
            headers: headers
        })
        .then(response => {
            if (response.status === 500) {
                localStorage.removeItem('acumen.user');
                localStorage.removeItem('acumen.session');
                localStorage.removeItem("acumen.branch");
                window.location.reload(true);
                const error = (response && response.message) || response.statusText;
                return Promise.reject(error);
            }
            
            return response;
        });
    },
    delete: async function(url, headers) {
        headers["Content-Type"] = "application/json";
        if(!headers["device-id"]){
            headers["device-id"] = "test";
        }
        // if(url.includes('?')){
        //     url= `${url}&user_type=${localStorage.getItem('acumen.user_type')}&user_code=${localStorage.getItem('acumen.user_code')}`
        // } else {
        //     url= `${url}?user_type=${localStorage.getItem('acumen.user_type')}&user_code=${localStorage.getItem('acumen.user_code')}`
        // }
        headers["sysbrew-x-token"] = localStorage.getItem('acumen.session');
        headers["app-version"] = global.appVersion;
        headers["platform"] = 'web';
         return fetch(url, {
             method: "DELETE",
             headers: headers
         });
    },
    post:  async function(url, headers, body) {
        headers["Content-Type"] = "application/json";
        if(!headers["device-id"]){
            headers["device-id"] = "test";
        }
        // if(url.includes('?')){
        //     url= `${url}&user_type=${localStorage.getItem('acumen.user_type')}&user_code=${localStorage.getItem('acumen.user_code')}`
        // } else {
        //     url= `${url}?user_type=${localStorage.getItem('acumen.user_type')}&user_code=${localStorage.getItem('acumen.user_code')}`
        // }
        headers["sysbrew-x-token"] = localStorage.getItem('acumen.session');
        headers["app-version"] = global.appVersion;
        headers["platform"] = 'web';
         return fetch(url, {
             method: "POST",
             headers: headers,
             body: body ? JSON.stringify(body) : null
         })
         .then(response => {
            if (response.status === 500) {
                localStorage.removeItem('acumen.user');
                localStorage.removeItem('acumen.session');
                localStorage.removeItem("acumen.branch");
                window.location.reload(true);
                const error = (response && response.message) || response.statusText;
                return Promise.reject(error);
            }
            return response;
        });
    },
    postFormData:  async function(url, headers, body) {
        headers["enctype"] = "multipart/form-data";
        if(!headers["device-id"]){
            headers["device-id"] = "test";
        }
        // if(url.includes('?')){
        //     url= `${url}&user_type=${localStorage.getItem('acumen.user_type')}&user_code=${localStorage.getItem('acumen.user_code')}`
        // } else {
        //     url= `${url}?user_type=${localStorage.getItem('acumen.user_type')}&user_code=${localStorage.getItem('acumen.user_code')}`
        // }
        headers["sysbrew-x-token"] = localStorage.getItem('acumen.session');
        headers["app-version"] = global.appVersion;
        headers["platform"] = 'web';
         return fetch(url, {
             method: "POST",
             headers: headers,
             body: body
         })
         .then(response => {
            if (response.status === 500) {
                localStorage.removeItem('acumen.user');
                localStorage.removeItem('acumen.session');
                localStorage.removeItem("acumen.branch");
                window.location.reload(true);
                const error = (response && response.message) || response.statusText;
                return Promise.reject(error);
            }
            return response;
        });
    }
};
